import * as React from 'react';
import { CobrandHeaderLogo } from './cobrand_header-logo';
export var CobrandHeaderImageToolbar = function (_a) {
    var headerImg = _a.headerImg;
    if (!headerImg || !headerImg.sectionData || headerImg.sectionData.length < 1) {
        return null;
    }
    return headerImg.sectionData
        .filter(function (item) { return item && (item.type === 'link' || item.type === 'img'); })
        .map(function (item, index) {
        var imgSrc = item.imgSrc, text = item.text, url = item.url;
        return React.createElement(CobrandHeaderLogo, { key: item, logoUrl: imgSrc, logoAltText: text, logoHref: url });
    });
};
//# sourceMappingURL=cobrand_header-image-toolbar.js.map